import { motion } from "framer-motion";
import { Shield, BadgeCheck, MapPin, Wrench, Award, Star } from "lucide-react";

const badges = [
  {
    icon: Star,
    label: "4.8 Stars",
    sub: "Rated on Google by real clients",
    accent: true,
    href: "https://g.page/r/CbV9TiDlQW8GEAE/review",
  },
  {
    icon: Award,
    label: "Checkatrade Approved",
    sub: "Listed & vetted on Checkatrade.com",
  },
  {
    icon: Shield,
    label: "Public Liability",
    sub: "Fully insured up to £1m",
  },
  {
    icon: BadgeCheck,
    label: "DBS Checked",
    sub: "Verified background — safe in your property",
  },
  {
    icon: Wrench,
    label: "Qualified Trade",
    sub: "Hands-on property experience",
  },
  {
    icon: MapPin,
    label: "Local & Independent",
    sub: "No subcontractors. No agency markup.",
  },
];

export default function TrustBadges() {
  return (
    <section className="py-16 border-y border-[#0B1215]/10 bg-[#F8F9FA]" data-testid="trust-badges">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="font-mono-label text-[#FF5A36] mb-8 text-center">· WHY YOU CAN TRUST ME</div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((b, i) => {
            const Icon = b.icon;
            const Wrapper = b.href ? "a" : "div";
            const wrapperProps = b.href ? { href: b.href, target: "_blank", rel: "noopener noreferrer" } : {};
            return (
              <motion.div
                key={b.label}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
              >
                <Wrapper
                  {...wrapperProps}
                  className={`border-2 p-5 flex items-start gap-3 transition-colors group block h-full ${
                    b.accent
                      ? "border-[#FF5A36] bg-[#FF5A36] text-[#F8F9FA] hover:bg-[#E04928]"
                      : "border-[#0B1215] bg-[#F8F9FA] hover:bg-[#0B1215] hover:text-[#F8F9FA]"
                  }`}
                  data-testid={`trust-badge-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center shrink-0 ${b.accent ? "bg-[#0B1215] text-[#FF5A36]" : "bg-[#FF5A36] text-[#F8F9FA]"}`}>
                    <Icon size={18} strokeWidth={2} className={b.accent ? "fill-[#FF5A36]" : ""} />
                  </div>
                  <div>
                    <div className="font-display text-base sm:text-lg tracking-tight leading-none">{b.label}</div>
                    <div className="text-xs mt-1.5 opacity-80 leading-snug">{b.sub}</div>
                  </div>
                </Wrapper>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
